import React from 'react';
import { FaLinkedin, FaGithub, FaInstagram } from 'react-icons/fa';
import { SiResearchgate, SiOrcid } from 'react-icons/si';

export default function Footer() {
  return (
    <footer className="bg-gray-800 text-gray-100 py-8 px-4 mt-20">
      <div className="max-w-6xl mx-auto flex flex-col items-center space-y-2">
        <div className="flex gap-8 text-2xl">
          <a
            href="https://www.linkedin.com/in/rajeevan-m-s-35947a191"
            title="LinkedIn"
            className="hover:text-blue-400 transition duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin />
          </a>
          <a
            href="https://www.researchgate.net/profile/M-S-Rajeevan"
            title="ResearchGate"
            className="hover:text-green-400 transition duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiResearchgate />
          </a>
          <a
            href="https://orcid.org/0009-0009-3320-3078" // Replace with your actual ORCID
            title="ORCID"
            className="hover:text-green-300 transition duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <SiOrcid />
          </a>
          <a
            href="https://github.com/msrajeevan96"
            title="GitHub"
            className="hover:text-gray-400 transition duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaGithub />
          </a>
          <a
            href="https://www.instagram.com/msrajeevan?igsh=ZXZhZ2N6d3MxbW8y"
            title="Instagram"
            className="hover:text-pink-400 transition duration-200"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaInstagram />
          </a>
        </div>

        <p className="text-sm text-gray-400">
          © {new Date().getFullYear()} M S Rajeevan. All rights reserved.
        </p>
        <p className="text-sm mt-1 text-gray-400">
          Designed and developed by M S Rajeevan
        </p>

        {/* 
        <p className="footer-note text-[10px] mt-1 text-gray-500 text-center max-w-full">
          Published: July 22, 2025&nbsp;|&nbsp;Last updated: July 25, 2025
        </p>
        */}
      </div>
    </footer>
  );
}
